import { Flex } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Text } from '../typography';

interface SavingsBadgeProps {
    value: number;
}
export const SavingsAmountBadge = ({ value = 0 }: SavingsBadgeProps): JSX.Element => (
    <Flex
        paddingX={1}
        paddingY={0.5}
        background="slt-pepper.100"
        alignItems="center"
        justifyContent="center"
        height="fit-content"
        shrink={0}
    >
        <Text id="savings-amount-badge" size="xs">
            <FormattedMessage
                id="savings.amount.badge"
                // eslint-disable-next-line no-template-curly-in-string
                defaultMessage="Save ${value}"
                values={{ value }}
            />
        </Text>
    </Flex>
);
